import { useCallback, useState } from 'react';
import { SsoService, TenantEmailDiscoveryResponse } from 'api';
import { isEmailLike } from 'pages/Auth/SignIn/SignIn.utils';

const useSignInSsoDiscovery = () => {
  const [ssoDiscovery, setSsoDiscovery] = useState<TenantEmailDiscoveryResponse | null>(null);

  const discoverSso = useCallback(async (identifier: string | null) => {
    if (!identifier || !isEmailLike(identifier)) {
      setSsoDiscovery(null);
      return null;
    }

    try {
      const response = await SsoService.apiSsoDiscoverCreate({ email: identifier });
      setSsoDiscovery(response);
      return response;
    } catch {
      setSsoDiscovery(null);
      return null;
    }
  }, []);

  const resetSsoDiscovery = useCallback(() => {
    setSsoDiscovery(null);
  }, []);

  return {
    discoverSso,
    resetSsoDiscovery,
    ssoDiscovery,
  };
};

export default useSignInSsoDiscovery;
